__turbopack_context__.v({
  "headerLayoutContainer": "styles-module-scss-module__6JNlLq__headerLayoutContainer",
  "headerLayoutContainerWithMenu": "styles-module-scss-module__6JNlLq__headerLayoutContainerWithMenu",
  "headerLayoutContainerWithMobileMenu": "styles-module-scss-module__6JNlLq__headerLayoutContainerWithMobileMenu",
  "headerLayoutFixedContainer": "styles-module-scss-module__6JNlLq__headerLayoutFixedContainer",
  "headerLayoutStaticContainer": "styles-module-scss-module__6JNlLq__headerLayoutStaticContainer",
  "headerWrapper": "styles-module-scss-module__6JNlLq__headerWrapper",
  "hideBreadcrumbsWhenHeaderMenuOpened": "styles-module-scss-module__6JNlLq__hideBreadcrumbsWhenHeaderMenuOpened",
  "marketDataMenuWrapper": "styles-module-scss-module__6JNlLq__marketDataMenuWrapper",
  "menuOverlay": "styles-module-scss-module__6JNlLq__menuOverlay",
  "menuWrapper": "styles-module-scss-module__6JNlLq__menuWrapper",
  "minimizeBreadcrumbsWhenMobileScroll": "styles-module-scss-module__6JNlLq__minimizeBreadcrumbsWhenMobileScroll",
  "stickyContent": "styles-module-scss-module__6JNlLq__stickyContent",
  "stickyContentFixed": "styles-module-scss-module__6JNlLq__stickyContentFixed",
  "stickyContentOpened": "styles-module-scss-module__6JNlLq__stickyContentOpened",
});
